import { ContentTopBar } from 'components';
import { AddSubModal } from 'features/management-report/components/modal/add-subscription';
import { EditSubViewModal } from 'features/management-report/components/modal/edit-subscription';
import { useState } from 'react';

type RoleProps = {
  setEditSubscriptionModal: any;
  editSubscriptionModal: boolean;
  editSubData: any;
  // handleFilter: (values: SubFormFilterValues) => void;
  // getInitialFilter: SubFormFilterValues;
};

export const SubscriptionTopBar = ({
  setEditSubscriptionModal,
  editSubscriptionModal,
  editSubData,
}: // handleFilter,
// getInitialFilter,
RoleProps) => {
  useState<any>();
  const [showAddSubModal, setShowAddSubModal] = useState(false);

  return (
    <>
      <ContentTopBar
        title={'Management Report List'}
        renderButtons={
          <>
            {showAddSubModal && (
              <AddSubModal onClose={() => setShowAddSubModal(false)} />
            )}
            {editSubscriptionModal && (
              <EditSubViewModal
                onClose={() => setEditSubscriptionModal(false)}
                editSubData={editSubData}
              />
            )}
          </>
        }
      />
    </>
  );
};
